// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line no-restricted-imports
import versionInfo from '../../../../package.json';

export const environment = {
    appVersion: versionInfo.version + '-qa',
    production: false,
    apiUrl: 'https://mm-org-admin-service-public.kube.qa.mmicse.com',
    keycloakConfig: {
        url: 'https://ssoqa01-lb-01.m2qa.com/auth',
        clientId: 'frontend-internal'
    },
    orgAdminProtocol: 'https',
    orgProtocol: 'https',
    sourceSystem: 'ENTERPRISE_SYSADMIN',
    auditReportPollIntervalMs: 5000
};
